import { useLazyQuery } from '@apollo/client';
import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import LoaderComponent from '../../../../../components/LoaderComponent';
import { TOY_ADMIN } from '../graphql/Queries';
import {
  mapChecklistToForm,
  mapRequiredContentsToForm,
} from '../toyContentUtils';
import ToyForm from './ToyForm';

const ToyDetailsContent = ({ toyId, onToyLoaded }) => {
  const [form] = Form.useForm();
  const [toyDetail, setToyDetail] = useState({});
  const [isToyLoading, setIsToyLoading] = useState(true);
  const [toyImages, setToyImages] = useState([]);
  const [featuredImage, setFeaturedImage] = useState([]);
  const [toyVideo, setToyVideo] = useState([]);

  const [toyAdmin] = useLazyQuery(TOY_ADMIN, {
    onCompleted: (response) => {
      const toyImagesArray = response?.toyAdmin?.images;
      const featuredImageObj = toyImagesArray?.shift();
      setToyImages(toyImagesArray);
      setFeaturedImage(featuredImageObj ? [featuredImageObj] : []);
      setToyVideo(
        response?.toyAdmin?.videoUrl
          ? { url: response?.toyAdmin?.videoUrl }
          : [],
      );
      const toy = {
        ...response?.toyAdmin,
        featuredImages: featuredImageObj ? [featuredImageObj] : [],
      };
      setToyDetail(toy);
      setIsToyLoading(false);
      if (onToyLoaded) {
        onToyLoaded(toy);
      }
    },
    fetchPolicy: 'network-only',
    onError() {
      setIsToyLoading(false);
    },
  });

  useEffect(() => {
    if (!toyId) return;
    setIsToyLoading(true);
    setToyDetail({});
    toyAdmin({
      variables: {
        where: {
          id: toyId,
        },
      },
    });
  }, [toyId]);

  const initialValues = {
    ...toyDetail,
    category: toyDetail?.categories?.map((category) => category?.id),
    ageGroup: toyDetail?.ageGroups?.map((ageGroup) => ageGroup?.id),
    brand: toyDetail?.brand?.id,
    material: toyDetail?.material?.id,
    packagingMaterial: toyDetail?.bag?.id,
    eanNumber: toyDetail?.eanNumber,
    price: toyDetail?.price,
    carbonEmission: toyDetail?.carbonEmission,
    id: toyDetail?.toyNumber,
    facilitates: toyDetail?.facilitates?.map((facilitate) => facilitate?.id),
    tags: toyDetail?.tags?.map((tag) => tag?.id),
    genres: toyDetail?.genres?.map((genre) => genre?.id),
    includedContentMasters: toyDetail?.includedContents?.map(
      (contentMaster) => ({
        id: contentMaster?.id,
        quantity: contentMaster?.quantity,
      }),
    ),
    requiredContents: mapRequiredContentsToForm(toyDetail?.requiredContents),
    checklist: mapChecklistToForm(toyDetail?.checklist),
    dimensions: toyDetail?.dimensions,
    type: toyDetail?.type,
    slug: toyDetail?.slug,
  };

  if (isToyLoading) {
    return (
      <LoaderComponent size="large" setHeight="60" spinning={isToyLoading} />
    );
  }

  return (
    <div className="toy-form">
      <ToyForm
        form={form}
        initialFormValues={initialValues}
        isView
        toyImages={toyImages}
        toyDetail={toyDetail}
        featuredImage={featuredImage}
        toyVideo={toyVideo}
        setToyVideo={setToyVideo}
        setFeaturedImage={setFeaturedImage}
      />
    </div>
  );
};

export default ToyDetailsContent;
